export const CANCEL_COURSE_TYPE_EDIT_STATE = "cancelCourseTypeEditState";
export const FETCH_COURSE_TYPE = "fetchCourseType";
export const FETCH_COURSE_TYPE_LIST = "fetchCourseTypes";
export const SAVE_COURSE_TYPE = "updateCourseTypeDetails";
export const SAVE_EDITED_COURSE_TYPE = "SAVE_EDITED_COURSE_TYPE";
export const DELETE_COURSE_TYPE = "DELETE_COURSE_TYPE";
export const SAVE_NEW_COURSE_TYPE = "SAVE_NEW_COURSE_TYPE";
